module.exports = __webpack_public_path__ + "static/img/item7@2x.ed243f69.png";